import {
    Box,
    Button,
    Chip,
    Icon,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { useContext } from "react";
import { SmsCampaignDto } from "../../../api/psc";
import { DialogContext } from "../../../contexts/DialogueContext";
import { toJalaliDate } from "../../../utils/date";
import { ParseSmsCampaignStatus } from "../constants/SmsCampaignContants";
import SmsCampaignRecordDialog from "../dialogs/SmsCampaignRecordDialog";

type Props = {
    smsCampaigns: SmsCampaignDto[];
};

// updated
export default function SmsCampaignListDesktop({ smsCampaigns }: Props) {
    const { openDialog } = useContext(DialogContext);

    const openRecordsDialog = (smsCampaign: SmsCampaignDto) => {
        openDialog(<SmsCampaignRecordDialog smsCampaign={smsCampaign} />);
    };

    return (
        // this is required to make paper box shadow visible
        <>
            <Box sx={{ p: 0.1 }}>
                <Paper>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>شناسه</TableCell>
                                    <TableCell>متن</TableCell>
                                    <TableCell>وضعیت</TableCell>
                                    <TableCell>سرشماره</TableCell>
                                    <TableCell>تعداد پیامک</TableCell>
                                    <TableCell>تعداد پارت</TableCell>
                                    <TableCell>تعداد پارت بازگشتی</TableCell>
                                    <TableCell>تاریخ ایجاد</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {smsCampaigns.map((row) => {
                                    const smsCampaignStatus =
                                        ParseSmsCampaignStatus(row.status);
                                    return (
                                        <TableRow
                                            key={row.id}
                                            sx={{
                                                "&:last-child td, &:last-child th":
                                                    { border: 0 },
                                            }}
                                        >
                                            <TableCell>{row.id}</TableCell>

                                            <TableCell sx={{ maxWidth: 250 }}>
                                                {row.template}
                                            </TableCell>

                                            <TableCell>
                                                <Chip
                                                    label={
                                                        smsCampaignStatus.text
                                                    }
                                                    size="small"
                                                    sx={{
                                                        bgcolor:
                                                            smsCampaignStatus.color,
                                                        color: "white",
                                                    }}
                                                />
                                            </TableCell>

                                            <TableCell>
                                                {row.gatewayNumber}
                                            </TableCell>

                                            <TableCell>
                                                {row.totalSmsCount}
                                            </TableCell>

                                            <TableCell>
                                                {row.totalPartCount}
                                            </TableCell>

                                            <TableCell>
                                                {row.refundedPartCount}
                                            </TableCell>

                                            <TableCell>
                                                {toJalaliDate(
                                                    row.createDate,
                                                    "YYYY/M/D HH:mm"
                                                )}
                                            </TableCell>

                                            <TableCell>
                                                <Button
                                                    size="small"
                                                    color="secondary"
                                                    startIcon={
                                                        <Icon>summarize</Icon>
                                                    }
                                                    variant="outlined"
                                                    onClick={() => {
                                                        openRecordsDialog(row);
                                                    }}
                                                >
                                                    جزییات ارسال
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Box>
        </>
    );
}
